<template>
    <!-- 新增或修改表单开始 -->
    <div>

        <el-dialog :title="news.id == 0 ? '新增' : '修改'" :close-on-click-modal="false" :visible.sync="visible">

            <el-form ref="news" :model="news" label-width="80px" @keyup.enter.native="newsSubmit()">
                <el-form-item label="标题">
                    <el-input v-model="news.title"></el-input>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="news.description"> </el-input>
                </el-form-item>       
                <el-form-item label="状态">
                    <el-switch v-model="news.showStatus" active-color="#13ce66" active-value="1" inactive-value="0">
                    </el-switch>
                </el-form-item>
                <el-form-item label="新闻栏目">
                    <el-select v-model="news.categoryId" width="100" clearable placeholder="请选择">
                        <el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select> 
                </el-form-item>
                <el-form-item label="作者">
                    <el-input v-model="news.author"></el-input>
                </el-form-item>
                <el-form-item label="来源">
                    <el-input v-model="news.origin"></el-input>
                </el-form-item>
                <el-form-item label="缩略图">  
                    <el-upload class="upload" ref="upload" :action="uploadUrl" name="file" accept=".png,.jpg" :on-preview="handlePreview" :on-remove="handleRemove"
                        :before-upload="beforeUpload" :on-success="handleSuccess" :auto-upload="false">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                        <el-button style="margin-left: 10px" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
                        <div slot="tip" class="el-upload__tip">
                            只能上传 .png .jpg图片，且不超过10MB
                        </div>
                    </el-upload>
                </el-form-item>

                <!-- <el-form-item label="内容">
                    <Editor></Editor>
                </el-form-item> -->

                <el-form-item>
                    <!-- <el-button type="primary" @click="newsSubmit">
                        <i v-if="news.id">
                            添加新闻内容
                        </i>
                        <i v-else>
                            修改新闻内容
                        </i>
                    </el-button> -->
                    <el-button type="primary" @click="newsSubmit">保存修改</el-button>
                    <el-button @click="visible=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
    <!-- 新增或修改表单结束 -->
</template>

<script>
// import Editor from "./wangeditor";

export default {
  components: {
    // Editor
  },

  data() {
    return {
      visible: false,
      news: {
          showStatus: {
              type:Number,
              default:0,
          }
      },
      categories: [],
      uploadUrl: null
    };
  },

  activated() {
    this.getCategories();
  },
  methods: {
    init(id) {
      let that = this
      that.news.id = id || 0;
      that.visible = true;
      that.getCategories();
      that.$nextTick(() => {
        that.$refs["news"].resetFields();
        that.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
        if (that.news.id) {
          that.$http({
            url: that.$http.adornUrl(`/news/${that.news.id}`),
            method: "get",
            params: that.$http.adornParams()
          }).then(({ data }) => {
            if (data && data.code === 0) {
              that.news = data.data;
            }
          });
        }
      });
    },

    // 提交数据
    newsSubmit() {
      let that = this
      console.log("数据：", that.news);

      // 更新新闻的数据

      that.$http({
        url: that.$http.adornUrl(
          `/news/${that.news.id == 0 ? "save" : "update"}`
        ),
        method: "post",

        data: that.$http.adornData(
          {
            id:
              that.news.id == undefined || that.news.id == 0
                ? null
                : that.news.id,
            title: that.news.title,
            author: that.news.author,
            showStatus: that.news.showStatus,
            categoryId: that.news.categoryId,
            description: that.news.description,
            origin: that.news.origin,
            thumb: that.news.thumb,
            checkStatus: that.news.checkStatus
          },
          false
        )
      }).then(({ data }) => {
        console.log("保存新闻：", data);
        that.news = {};
        that.visible = false;
      });
    },

    // 获取新闻栏目信息
    getCategories() {
      this.$http({
        url: this.$http.adornUrl("/category/list/EC000103"),
        method: "get"
      }).then(({ data }) => {
        console.log("新闻栏目：", data.data);
        this.categories = data.data;
      });
    },

    // ================================================文件上传相关方法=======================================
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.deleteFile(file);
    },
    handlePreview(file) {
      console.log(file);
      window.open(file.url, "_blank").location;
    },
    beforeUpload(file) {
      const isLt100M = file.size / 1024 / 1024 < 10;
      if (!isLt100M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isLt100M;
    },
    handleSuccess(response) {
                console.log(response);
      if (response && response.code === 0) {
        console.log("文件上传成功返回结果：", response.data);
        this.news.thumb = response.data;
      }
    }
    // // 删除文件
    // deleteFile(file) {
    //   this.$http({
    //     // url: this.$http.adornUrl("/enterprise/deleteFile"),
    //     method: "get",
    //     params: this.$http.adornParams({
    //       id: this.dataForm.id,
    //       name: file.name,
    //       url: file.url,
    //     }),
    //   }).then(({ data }) => {
    //     if (data && data.code === 0) {
    //       this.$message({
    //         message: data.msg,
    //         type: "success",
    //       });
    //     } else {
    //       this.$message.error(data.msg);
    //     }
    //   });
    // },
    // // 查看文件
    // lookFile(id) {
    //   this.$http({
    //     // url: this.$http.adornUrl("/enterprise/lookFile/" + id),
    //     method: "get",
    //     params: this.$http.adornParams(),
    //   }).then(({ data }) => {
    //     if (data && data.code === 0) {
    //       this.fileList = data.data;
    //     }
    //   });
    // },
  }
};
</script>
